import { useContext } from "react";
import { AppStateContext } from "../../state/AppProvider";

interface Props {
    onNewClick: () => void;
    newDisabled?: boolean;
    onHistoryClick: () => void;
    windowWidth: number;
}

export const ChatHeader = ({ onNewClick, newDisabled, onHistoryClick, windowWidth }: Props) => {
    const appStateContext = useContext(AppStateContext);

    return (
        <div className="sticky top-0 px-4 lg:px-[3.75rem] py-3 flex items-center justify-between z-20 h-14 font-semibold bg-j-dark">
            {windowWidth >= 768 && (
                <div className="flex items-center overflow-hidden gap-0">
                    <div className="text-j-white font-bold text-lg">Reggie (beta)</div>
                </div>
            )}
            {!appStateContext?.state.isChatHistoryOpen && (
                <div className="flex items-center overflow-hidden gap-3">
                    <button
                        className={
                            "flex w-32 justify-center rounded-lg px-3 py-1.5 text-sm font-bold leading-6" +
                            (newDisabled
                                ? " text-j-light-grey bg-j-super-light-grey cursor-default"
                                : " text-j-dark bg-gradient-to-r from-j-green to-j-cyan cursor-pointer hover:from-j-green-hover hover:to-j-cyan-hover")
                        }
                        onClick={onNewClick}
                    >
                        <span>New chat</span>
                    </button>
                    <button
                        className="flex w-32 justify-center rounded-lg bg-j-dark px-3 py-1.5 text-sm font-bold leading-6 text-j-white border-solid border-2 border-j-green hover:bg-j-dark-hover"
                        onClick={onHistoryClick}
                    >
                        <span>{appStateContext?.state.isChatHistoryOpen ? "Hide history" : "Show history"}</span>
                    </button>
                </div>
            )}
        </div>
    );
};
